import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { environment } from './../../environments/environment';
import { SpinnerService as Spinner } from '../shared/components/spinner/spinner.service';

@Injectable({
  providedIn: 'root',
})
export class ForgotPasswordService {
  private baseUrl = `${environment.apiUrl}`;

  constructor(private http: HttpClient, private spinner: Spinner) {}

  sendRecoveryEmail(email: string): Observable<{ status: string }> {
    this.spinner.open({
      title: 'Enviando correo',
      message: 'Estamos enviando el código de recuperación.',
    });

    return this.http
      .post<{ status: string }>(`${this.baseUrl}/backoffice/forgot-password`, { email })
      .pipe(
        finalize(() => {
          this.spinner.close();
        })
      );
  }

  resetPasswordWithToken(payload: {
    email: string;
    token: string;
    password: string;
    password_confirmation: string;
  }): Observable<{ status: string }> {
    this.spinner.open({
      title: 'Actualizando contraseña',
      message: 'Por favor, esperá mientras actualizamos tu contraseña.',
    });

    return this.http
      .post<{ status: string }>(`${this.baseUrl}/backoffice/reset-password`, payload)
      .pipe(
        finalize(() => {
          this.spinner.close();
        })
      );
  }
}
